document.querySelectorAll('.our-story-values-slider').forEach((slider) => {
  if (slider.classList.contains('swiper-initialized')) return;

  new Swiper(slider, {
    loop: false,
    grabCursor: true,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 16,
    watchSlidesProgress: true,
    watchOverflow: true,
    threshold: 10,
    observer: true,
    observeParents: true,
    mousewheel: {
      forceToAxis: true,
    },
  });
});
